module.exports = __webpack_public_path__ + "img/theme4.cc306c0f.png";